import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";

import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";

import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { EditarSubCategories, getCategories, GuardarSubCategories } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

const SubCategoriesCRUD = ({
  showDialog,
  selected,
  setSelected,
  setShowDialog,
  getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [dialogTitle, setDialogTitle] = useState('');

  const initialValues = {
    IdSubCategoria: -1,
    IdStatus: selected?.IdStatus ? selected?.IdStatus : 5,
    StatusName: selected?.StatusName ? selected?.StatusName : 'Activo',
    SubCategoria: '',
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    
    const estadosTempo = await getEstadosCategory('General')
    let est = estadosTempo.filter(i=> i?.IdStatus !== 7) 

    let estadoInicial
    if(selected?.IdSubCategoria){
      setDialogTitle("Editar Sub Categoría")
      estadoInicial =  estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);
    }else{
      setDialogTitle("Agregar Sub Categoría")
      estadoInicial =  estadosTempo[0]
    }
    setEstados(est)

    const categoriesTempo = await getCategories()
    setCategorias(categoriesTempo)

    setValues({
      ...selected,
      IdSubCategoria: selected?.IdSubCategoria > 0 ? selected?.IdSubCategoria : -10,
      IdStatus: estadoInicial?.IdStatus,
      StatusName: estadoInicial,
      IdCategoria: selected?.IdCategoria ? selected?.IdCategoria : null,
      Categoria: selected?.Categoria ? selected?.Categoria : '',
    })
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null)
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.CodigoSubCategoria) {
      error.CodigoSubCategoria = true;
      error.error = true;
    }
    if (!values.SubCategoria) {
      error.SubCategoria = true;
      error.error = true;
    }
    if (!values.Categoria?.IdCategoria && !values?.IdCategoria) {
      error.IdCategoria = true;
      error.error = true;
    }
    if (!values.StatusName?.IdStatus && !values?.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){

      const Datos = {
        IdSubCategoria: values?.IdSubCategoria ? values?.IdSubCategoria : -100,
        CodigoSubCategoria: values?.CodigoSubCategoria,
        SubCategoria: values?.SubCategoria,
        IdCategoria: values?.Categoria?.IdCategoria || values?.IdCategoria,
        IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
        Descripcion: values?.Descripcion,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      }

      setLoading(true);
      if (Datos?.IdSubCategoria > 0) {
        const respuesta = await EditarSubCategories(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Editado", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarSubCategories(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }

    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
        getValoresIniciales();
    }
  }, [showDialog]);


  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h3 className="mx-4">{dialogTitle}</h3>
            </div>
            <Toast ref={toast} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="CodigoSubCategoria"
                    value={values.CodigoSubCategoria}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.CodigoSubCategoria ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoSubCategoria">Código</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="SubCategoria"
                    value={values.SubCategoria}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.SubCategoria ? "p-invalid" : ""}
                  />
                  <label htmlFor="SubCategoria">Sub Categoría</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Categoria"}
                    value={values.Categoria}
                    items={categorias}
                    field={"Categoria"}
                    label={"Categoría"}
                    handleInputChange={handleInputChange}
                    className={error.IdCategoria ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"StatusName"}
                    value={values.StatusName}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    enable={dialogTitle !== "Agregar Sub Categoría"}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SubCategoriesCRUD;
